import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SetupStatusItem } from '../../models/setup-status';

@Component({
  selector: 'app-onboarding-checklist-item',
  templateUrl: './onboarding-checklist-item.component.html',
  styleUrls: ['./onboarding-checklist-item.component.scss'],
})
export class OnboardingChecklistItemComponent {
  @Input() item: SetupStatusItem;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  constructor(private router: Router) {}

  handleActionClick() {
    if (!this.item.completed && !(this.item.action_url === null || this.item.action_url === '')) {
      this.router.navigateByUrl(new URL(this.item.action_url).pathname);
      this.close.emit();
    }
  }

  handleHelpClick() {
    window.open(this.item.support_url, '_blank');
  }
}
